var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldSwitch, FlexBox, Table } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';
import { analytics } from 'app/utils/segment';
import styles from '../tags.module.scss';
export class TagsTableRow extends PureComponent {
    handleToggleButtonChange() {
        const { tag, toggleActivation } = this.props;
        if (tag.is_deactivated) {
            analytics.settingsTagsTagActivated({ tagName: tag.name });
        }
        else {
            analytics.settingsTagsTagDeactivated({ tagName: tag.name });
        }
        toggleActivation(tag);
    }
    render() {
        var _a;
        const { tag } = this.props;
        return (_jsxs(Table.Tr, { children: [_jsx(Table.Td, { children: _jsxs(FlexBox, Object.assign({ alignItems: "center" }, { children: [_jsx("div", { className: styles.tagIndicator, style: { background: (_a = tag.color) !== null && _a !== void 0 ? _a : 'transparent' } }), _jsx("span", Object.assign({ className: styles.tagName }, { children: tag.name }))] })) }), _jsx(Table.Td, { children: tag.usage_count ? `${tag.usage_count} times` : 'unused' }), _jsx(Table.Td, { children: _jsx(FieldSwitch, { input: {
                            name: 'active',
                            value: 'active',
                            checked: !tag.is_deactivated,
                            onChange: () => this.handleToggleButtonChange(),
                        } }) })] }));
    }
}
__decorate([
    boundMethod
], TagsTableRow.prototype, "handleToggleButtonChange", null);
